export const DROP_ZONES = {
	MY_SONG_NAV: 'droppable-my-songs--opacity', // opacity will help with styles for song row
	INSTRUCTOR_PLAYLIST: 'droppable-song-list',
	PLAYLIST_RAIL_PLAYLIST: 'droppable-playlist-rail--opacity',
	SONGS_TABLE: 'droppable-song-table',
};
